﻿import { apiPromise, htmlPromise } from '../../../../Resources/Scripts/_Shared/fetch'
import { mockedFacilities, mockedStockholm } from './MockedData'
import { calculateDistance } from './Helpers'

export const search = {
  getPricesProducts: async (data) => htmlPromise('/facilitypage/getpricesproductspartial', data).catch((err) => err),
  getNearbyFacilities: async (data) => new Promise((resolve) => {
    if (!data.location && !data.reloadLocation) return;
    const parsedData = {
      latitude: data.reloadLocation ? data.reloadLocation.lat : data.location.lat,
      longitude: data.reloadLocation ? data.reloadLocation.lng : data.location.lng,
      maxDistance: data.radius ?? 5,
      withPmcs: false,
      size: data.size ?? 50,
      lang: data.lang,
      init: data.init
    };

    const facilitiesResult = apiPromise('/booking/getnearbyfacilities', parsedData).catch((err) => err);

    facilitiesResult.then(result => {
      if (result.status !== 200) {
        resolve({ status: 200, info: 'OK', body: [] });
        return;
      }
      if (data.reloadLocation) {
        const appendFacilitiesResult = [];

        for (let i = 0; i < result.body.length; i++) {
          const startCoordinates = {
            latitude: result.body[i].Address.Marker.Coordinates[1],
            longitude: result.body[i].Address.Marker.Coordinates[0]
          };
          const endCoordinates = {
            latitude: data.location.lat,
            longitude: data.location.lng,
          };
          const Distance = calculateDistance(startCoordinates, endCoordinates, { unit: 'km' });
          appendFacilitiesResult.push({ ...result.body[i], Address: { ...result.body[i].Address, Distance } });
        }

        resolve({ status: 200, info: 'OK', body: appendFacilitiesResult });
      } else {
        resolve({ status: 200, info: 'OK', body: result.body });
      }
    })
  }),
}

const apiMockedPromise = (url, data, returnTime = 0) => {
  return new Promise((resolve) => {
    let returnData;
    //let returnTime = 3000; //Milliseconds

    if (url.lastIndexOf('/booking/getnearbyfacilities', 0) === 0) {
      const parsedData = data ? {
        lat: data.reloadLocation ? data.reloadLocation.lat : data.location.lat,
        lng: data.reloadLocation ? data.reloadLocation.lng : data.location.lng,
      } : null;
      returnData = mockedFacilities(parsedData);
    }
    else
      returnData = 'No mocked api endpoint match!'

    console.log(`Mocked data: ${url}`, { status: 200, info: 'OK', body: returnData })

    setTimeout(() => {
      resolve({ status: 200, info: 'OK', body: returnData });
    }, returnTime === 0 ? (Math.floor(Math.random() * 5) * 1000) : returnTime);
  });
}

